import SpotSocketClient, { SocketType } from '@/utils/spotSocketClient';

const SpotWebsocketInstance = (url: string, type: SocketType) => new SpotSocketClient(url, type, (data: any) => data);

export default SpotWebsocketInstance;
